/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * An enumeration.
 */
export enum ArchiveStateEnum {
  ACTIVE = "ACTIVE",
  ALL = "ALL",
  ARCHIVED = "ARCHIVED",
}

/**
 * An enumeration.
 */
export enum LANGUAGES {
  de = "de",
  nl = "nl",
}

/**
 * An enumeration.
 */
export enum QuestionnaireStateEnum {
  MADE = "MADE",
  SENT = "SENT",
}

/**
 * An enumeration.
 */
export enum UserRole {
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
  COACH = "COACH",
  FAN = "FAN",
  SUPERADMIN = "SUPERADMIN",
}

export interface CoachMutationInput {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  isActive?: boolean | null;
  role?: string | null;
  language?: string | null;
  tenant?: string | null;
  id?: string | null;
  clientMutationId?: string | null;
}

export interface SendQuestionnaireInput {
  phoneNumber: string;
  firstName: string;
  lastName: string;
}

export interface UserMutationInput {
  helpingMindTime?: any | null;
  movementAndRelaxTime?: any | null;
  moodSnapshotTime?: any | null;
  paused?: boolean | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  notificationsEnabled?: boolean | null;
  language?: string | null;
  movementsEnabled?: boolean | null;
  archived?: boolean | null;
  id?: string | null;
  clientMutationId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
